import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { markdownToHtml } from '../lib/markdown';
import { cardStyles, motionStyles, pageFrameStyles, proseStyles } from '../styles/lit-shared';

@customElement('legal-page')
export class LegalPage extends LitElement {
  @property({ type: String }) title = '';
  @property({ type: String }) content = '';
  @property({ type: String }) updatedAt = '10 de julio de 2026';

  static styles = [
    pageFrameStyles,
    motionStyles,
    cardStyles,
    proseStyles,
    css`
      .page {
        max-width: 720px;
        margin-inline: auto;
      }

      .page-header {
        margin-bottom: var(--space-xl);
      }

      .page-header h1 {
        margin: 0 0 var(--space-sm);
        font-size: clamp(1.75rem, 4vw, 2.25rem);
        letter-spacing: -0.03em;
      }

      .updated {
        margin: 0;
        font-size: 0.875rem;
        color: var(--color-text-subtle);
      }
    `,
  ];

  render() {
    return html`
      <article class="page animate-fade-up">
        <header class="page-header">
          <h1 class="text-gradient">${this.title}</h1>
          <p class="updated">Última actualización: ${this.updatedAt}</p>
        </header>
        <div class="card article-body" .innerHTML=${markdownToHtml(this.content)}></div>
      </article>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'legal-page': LegalPage;
  }
}
